/* eslint react/prefer-stateless-function: 0 */

import React from 'react';
import { Text, View } from 'react-native';
import { Button } from 'react-native-elements';
import ReactRouterPropTypes from 'react-router-prop-types';

import AORTypes from '../../types';
import styles from '../../styles';
import { translate } from '../../locales/i18n';

class PublisherAppAdded extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'PublisherAppAdded';
  }

  render() {
    const { user, history } = this.props;

    return (
      <View
        style={styles.view.headless}
      >
        <Text
          style={{
            fontFamily: styles.primaryFont700,
            fontSize: 32,
            fontWeight: '700',
            alignSelf: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            paddingBottom: 52,
            paddingHorizontal: 20,
          }}
        >
          {translate('published_title')}
        </Text>
        <Text
          style={{
            fontFamily: styles.primaryFont400,
            fontSize: 14,
            fontWeight: '400',
            alignSelf: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            paddingVertical: 32,
            paddingHorizontal: 20,
          }}
        >
          {translate('published_par1')}
        </Text>
        <Text
          style={{
            fontFamily: styles.primaryFont400,
            fontSize: 14,
            fontWeight: '400',
            alignSelf: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            paddingHorizontal: 20,
          }}
        >
          {translate('published_par2')}
        </Text>
        <Text
          style={{
            fontFamily: styles.primaryFont400,
            fontSize: 14,
            fontWeight: '400',
            alignSelf: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            paddingHorizontal: 20,
          }}
        >
          {translate('published_par3')}
        </Text>

        <View>
          <Button
            title={translate('button_continue')}
            containerStyle={{
              marginTop: 40,
              alignSelf: 'center',
            }}
            buttonStyle={styles.button.primary}
            disabledStyle={styles.button.primaryDisabled}
            titleStyle={styles.button.primaryTitle}
            disabledTitleStyle={styles.button.primaryTitleDisabled}
            onPress={() => {
              if (user && user.username) {
                history.push('/my-ai-agents');
              } else {
                history.push('/signin/my-ai-agents');
              }
            }}
          />
        </View>
      </View>
    );
  }
}

PublisherAppAdded.defaultProps = {
  user: null,
};

PublisherAppAdded.propTypes = {
  user: AORTypes.AWS.Cognito.User,
  history: ReactRouterPropTypes.history.isRequired,
};

export default PublisherAppAdded;
